module.exports = __webpack_public_path__ + "static/Dark-Orange-d6ba86ec56f2702cedf83d8a0846b107.png";